module.exports = __webpack_public_path__ + "img/20200512_161844.78c16b60.jpg";